import { useEffect, useState, useRef } from "react";
import {
  UPDATE_PROPERTY_BY_CLIENT_ID,
  // POST_PROPERTY_FLOOR_IAMGE,
  POST_PROPERTY_COMPLIANCE_DOCS,
  GET_FLOOR_DETAILS_BY_PROPERTY_CLIENT,
  DELETE_COMPLIANCE_DOC,
  DELETE_FLOOR_PLAN_IMAGE,
  UPLOAD_PROPERTY_UPDATE_IMAGE,
  GET_BLOCK_DATA,
  DELETE_BLOCK_DOCUMENT,
  UPDATE_BLOCKS_DATA,
} from "../api/apiPath";
import { hostName } from "../config/config";
import http from "../api/server";
import { useSelector } from "react-redux";
import FileUpload from "./common/FileUpload";
// import { IconButton } from "@mui/material";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { generatePath, useParams } from "react-router-dom";

import delicon from "../assets/img/del.png";

import Select from "react-select";
import ConfirmationPopup from "./common/ConfirmationPopup";
import LoadingComponent from "./common/LoadingComponent";
const UpdateProperty = (props) => {
  const {
    clientId,
    editPropertyDetails,
    // blocksList,
    setRenderUpdateProperty,
    handleGetAllPropertyByClinetID,
    cityList,
    inspectorList,
    approverList,
    setToastData,
  } = props;
  const { clientNameParam } = useParams();
  //const [propertyCity, setPropertyCity] = useState(editPropertyDetails?.city);
  const [savedFloorImages, setSavedFloorImages] = useState(null);
  const [savedCompDocs, setSavedCompDocs] = useState(null);
  // const [floorError, setFloorError] = useState("");
  const [showConfirmationPopup, setShowConfirmationPopup] = useState({
    show: false,
    headingText: "",
    infoText: "",
    cancelText: "",
    submittext: "",
  });
  const [activeTab, setActiveTab] = useState("Site"); //or Block

  const handleTabChange = (e) => {
    setActiveTab(e);
    setValidationFlag(false);
  };
  const [loading, setLoading] = useState(false);
  const [floorNumberToDelete, setFloorNumberToDelete] = useState(null);
  console.log("editpr", editPropertyDetails);
  const [loadExistingFile, setLoadExistingFile] = useState(
    editPropertyDetails?.propertyImage === null ||
      editPropertyDetails?.propertyImage === ""
      ? true
      : false
  );
  const { userObj } = useSelector((state) => state.user);
  const ImageProxyBaseUrl = hostName + "/api/Inspection/api/image?blobUrl=";
  // const editPropertyBlockObj = {
  //   blockId:
  //     editPropertyDetails?.blockId === "00000000-0000-0000-0000-000000000000"
  //       ? null
  //       : editPropertyDetails?.blockId,
  //   blockName: editPropertyDetails?.blockName,
  // };
  const [propertyName, setPropertyName] = useState(
    editPropertyDetails?.propertyName
  );
  const [propertyAddress, setPropertyAddress] = useState(
    editPropertyDetails?.propertyLocation
  );
  const [propertyPostalCode, setPropertyPostalCode] = useState(
    editPropertyDetails?.postalCode
  );
  // const [propertyTotalFloor, setPropertyTotalFloor] = useState(
  //   editPropertyDetails?.totalNoOfFloors
  // );
  const [siteLatitude, setSiteLatitude] = useState(editPropertyDetails?.lat);
  const [siteLongitude, setSiteLongitude] = useState(editPropertyDetails?.long);
  const [numberofBlocks, setNumberofBlocks] = useState(
    editPropertyDetails?.numberOfBlocks
  );
  const [blockData, setBlockData] = useState([]);
  // const [showFloorImages, setShowFloorImages] = useState(
  //   editPropertyDetails?.totalNoOfFloors === null ||
  //     editPropertyDetails?.totalNoOfFloors === "0" ||
  //     editPropertyDetails?.totalNoOfFloors === 0
  //     ? false
  //     : true
  // );
  const editPropertyCityObj = {
    cityId: editPropertyDetails?.cityId,
    cityName: cityList?.find(
      (city) => city.cityId.toString() === editPropertyDetails?.cityId
    )?.cityName,
  };
  const [propertyCity, setPropertyCity] = useState(editPropertyCityObj);
  const [propertyStatus, setPropertyStatus] = useState(
    editPropertyDetails?.propertyStatus
  );
  const [propertyImage, setPropertyImage] = useState(
    editPropertyDetails?.propertyImage
  );
  // const [propertyBlockObj, setPropertyBlockName] =
  //   useState(editPropertyBlockObj);

  const [files, setFiles] = useState([]);
  const [validationFlag, setValidationFlag] = useState(false);

  // const [floorEntries, setFloorEntries] = useState([]);

  const [propertyInspector, setPropertyInspector] = useState(
    editPropertyDetails?.inspectors.map((inspector) => ({
      value: inspector.userId,
      label: inspector.userName ? inspector.userName : inspector.fullName,
    }))
  );
  const [propertyApprover, setPropertyApprover] = useState(
    editPropertyDetails?.approvers.map((approver) => ({
      value: approver.userId,
      label: approver.userName ? approver.userName : approver.fullName,
    }))
  );

  const editPropertyFloorDetails = async () => {
    try {
      const response = await http.get(
        hostName +
          GET_FLOOR_DETAILS_BY_PROPERTY_CLIENT +
          `?propertyId=${editPropertyDetails?.propertyMasterId}&clientId=${clientId}`
      );
      if (response.status === 200) {
        console.log("floor details", response?.data);
        setSavedFloorImages(response?.data?.floorDetails || []);
        setSavedCompDocs(response?.data?.complianceDocFiles || []);
      }
    } catch (error) {
      return {};
    }
  };

  const getBlockDetails = async () => {
    try {
      const response = await http.get(
        GET_BLOCK_DATA +
          `?PropertyMasterId=${editPropertyDetails?.propertyMasterId}&ClientId=${clientId}`
      );
      if (response.status === 200) {
        console.log("block deets", response, blockData);
        const data = response?.data;
        const blockArr = data?.map((block, index) => {
          return {
            id: index + 1,
            blockId: block.blockId,
            blockName: block.blockName,
            totalFloors: block.totalFloors,
            showFloorImages: false,
            savedfloorArray: (block?.floorPlans ?? []).map((floor) => ({
              blockFloorId: floor.blockFloorPlanDetailsId,
              floor: floor.floorNumber,
              image: floor.floorPlanImage,
              floorError: "",
            })),
            floorArray: (block?.floorPlans ?? []).map((floor) => ({
              blockFloorId: floor.blockFloorPlanDetailsId,
              floor: floor.floorNumber,
              image: floor.floorPlanImage,
              loadedImage: true,
              floorError: "",
            })),
            savedadditionalDocsArr: (
              block?.documents ??
              block?.Documents ??
              block?.Document ??
              []
            ).map((doc) => ({
              docId: doc.fileId,
              complianceType: doc.documentType,
              complianceFileName: doc.documentFileName,
              file: doc.documentFileUrl,
            })),
            additionalDocsArr: [],
            fileError: "",
            fileShowValidation: false,
            formErrors: {}, // add these
            hasFormErrors: false,
          };
        });
        console.log("block arr", blockArr);
        setBlockData(blockArr);
      }
    } catch (error) {
      return {};
    }
  };

  //inputrefs
  const inputRefs = {
    // block: useRef(null),
    propertyName: useRef(null),
    propertyAddress: useRef(null),
    postalCode: useRef(null),
    // totalFloor: useRef(null),
    city: useRef(null),
    inspectors: useRef(null),
    approvers: useRef(null),
    floorImages: useRef(null),
  };
  //errorObject for form validation
  const [errorObject, setErrorObject] = useState({
    // block: "",
    propertyName: "",
    propertyAddress: "",
    postalCode: "",
    city: "",
    inspectors: "",
    approvers: "",
    fileError: "",
  });

  const ukPostcodeRegex = /^([A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2})$/i;

  const isValidUKLatitude = (lat) => {
    const num = Number(lat);
    return !Number.isNaN(num) && num >= 49.5 && num <= 61;
  };

  const isValidUKLongitude = (lng) => {
    const num = Number(lng);
    return !Number.isNaN(num) && num >= -8 && num <= 2;
  };

  const validate = () => {
    const newErrors = {};
    // if (!propertyBlockObj?.blockName) newErrors.block = "Select Block";
    if (!propertyName) newErrors.propertyName = "Property Name is required";
    if (!propertyAddress)
      newErrors.propertyAddress = "Property Address is required";
    if (!propertyPostalCode) {
      newErrors.postalCode = "Postal Code is required";
    } else if (!ukPostcodeRegex.test(propertyPostalCode.trim())) {
      newErrors.postalCode = "Invalid UK Postal Code";
    }
    if (!numberofBlocks || numberofBlocks <= 0) {
      newErrors.numberOfBlocks = "Number of blocks is required";
    }
    if (!siteLatitude.trim() || !isValidUKLatitude(siteLatitude)) {
      newErrors.siteLatitude = "Enter valid UK Latitude";
    }
    if (!siteLongitude.trim() || !isValidUKLongitude(siteLongitude)) {
      newErrors.siteLongitude = "Enter valid UK Longitude";
    }
    if (!propertyCity?.cityName) newErrors.city = "Select City";
    if (propertyInspector && propertyInspector.length === 0)
      newErrors.inspectors = "Select at least one inspector";
    if (propertyApprover && propertyApprover.length === 0)
      newErrors.approvers = "Select at least one approver";
    for (const fe of files) {
      if (!fe.docName.trim()) {
        setError("Each file must have a document name.");
        setShowValidation(true);
        newErrors.fileError = "error in file data uploaded";
        break;
      }
      if (!fe.type) {
        setError("Each file must have a type selected.");
        setShowValidation(true);
        newErrors.fileError = "error in file data uploaded";
        break;
      }
      if (fe.file && fe.file.size > 10 * 1024 * 1024) {
        setError("Each file should not exceed 10 MB");
        setShowValidation(true);
        newErrors.fileError = "error in file data uploaded";
        break;
      }
    }

    const blockFileErrors = blockData.some((block, blockIndex) => {
      let hasFileError = false;
      
      for (const file of block.additionalDocsArr) {
        if (!file.docName.trim()) {
          handleBlockDataChange(blockIndex, "fileError", "Each file must have a document name.");
          handleBlockDataChange(blockIndex, "fileShowValidation", true);
          hasFileError = true;
          break;
        }
        if (!file.type) {
          handleBlockDataChange(blockIndex, "fileError", "Each file must have a type selected.");
          handleBlockDataChange(blockIndex, "fileShowValidation", true);
          hasFileError = true;
          break;
        }
        if (file.file && file.file.size > 10 * 1024 * 1024) {
          handleBlockDataChange(
            blockIndex,
            "fileError",
            "Each file must not exceed 10 MB."
          );
          handleBlockDataChange(blockIndex, "fileShowValidation", true);
          hasFileError = true;
          break;
        }
      }
      
      if (!hasFileError && block.additionalDocsArr.length > 0) {
        handleBlockDataChange(blockIndex, "fileError", "");
        handleBlockDataChange(blockIndex, "fileShowValidation", false);
      }
      
      return hasFileError;
    });

    if (blockFileErrors) {
      newErrors.blockFileError = "error in block file data uploaded";
    }

    const isPositiveInt = (n) => Number.isInteger(n) && n > 0 && n <= 200;

    const invalids = blockData
      .map((b, i) => ({
        index: i,
        id: b.id,
        blockNameEmpty: !String(b.blockName || "").trim(),
        totalFloorsInvalid: !isPositiveInt(Number(b.totalFloors)),
      }))
      .filter((x) => x.blockNameEmpty || x.totalFloorsInvalid);

    const allFloorsHaveImagesForAllBlocks = blockData.every(
      (block) =>
        block.floorArray.length > 0 &&
        block.floorArray.every((f) => f.image !== null)
    );

    if (invalids.length > 0 || !allFloorsHaveImagesForAllBlocks) {
      newErrors.blockData = "error in block data";
      setBlockData((prev) =>
        prev.map((b) => {
          const nameEmpty = !String(b.blockName || "").trim();
          const floorsInvalid =
            !Number.isInteger(Number(b.totalFloors)) ||
            Number(b.totalFloors) <= 0;
          const mustHaveImages = b.totalFloors > 0;

          const nextFloors = b.floorArray.map((f) => {
            const missing = mustHaveImages && f.image == null;
            return {
              ...f,
              floorError: missing ? "Floor image is required" : "",
            };
          });

          return {
            ...b,
            // You already have fileError/fileShowValidation; add form errors:
            formErrors: {
              ...b.formErrors,
              blockName: nameEmpty ? "Block name is required" : "",
              totalFloors: floorsInvalid
                ? "Total floors must be a positive integer between 1 - 200"
                : "",
            },
            hasFormErrors: nameEmpty || floorsInvalid,
            floorArray: nextFloors,
          };
        })
      );
    }

    return newErrors;
  };

  // const validateFloorEntries = (cleanedFloor) => {
  //   const isEmptyFloorEntries = checkFloorEntries(floorEntries);
  //   const newFloorEntries = [...cleanedFloor];
  //   if (floorEntries.length > 0 && !isEmptyFloorEntries) {
  //     newFloorEntries.forEach((entry) => {
  //       if (entry.floor !== "Select" && entry.floor !== "" && !entry.image)
  //         entry.requireImage = "Please upload floor plan image";
  //       if (entry.image && (!entry.floor || entry.floor === "Select"))
  //         entry.requireFloor = "Please select floor";
  //     });
  //   }
  //   return newFloorEntries;
  // };

  useEffect(() => {
    editPropertyFloorDetails();
    getBlockDetails();
  }, [editPropertyDetails]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setPropertyImage(file);
  };

  const [error, setError] = useState("");
  const [showValidation, setShowValidation] = useState(false);

  const uploadComplianceDocs = async (files) => {
    console.log("files", files);
    setLoading(true);
    const formDataToUploadCompliance = new FormData();
    formDataToUploadCompliance.append(
      "PropertyId",
      editPropertyDetails?.propertyMasterId
    );
    formDataToUploadCompliance.append("ClientId", clientId);
    console.log("formDataToUploadCompliance", files);
    files?.forEach((fileObj, index) => {
      formDataToUploadCompliance.append(
        `complianceDocUploadDtos[${index}].complianceType`,
        fileObj.type || 0
      );
      formDataToUploadCompliance.append(
        `complianceDocUploadDtos[${index}].complianceFileName`,
        fileObj.docName
      );
      formDataToUploadCompliance.append(
        `complianceDocUploadDtos[${index}].complianceFile`,
        fileObj.file
      ); //this is file obj
    });
    try {
      const response = await fetch(hostName + POST_PROPERTY_COMPLIANCE_DOCS, {
        method: "POST",
        body: formDataToUploadCompliance,
        headers: {
          Authorization: "Bearer " + userObj?.token,
        },
      });
      console.log("response", response, savedFloorImages);
      if (response?.status === 401) {
        window.location.href = generatePath("/client/:clientNameParam/", {
          clientNameParam,
        });
      }
      if (response.status !== 200) {
        throw new Error(`HTTP error! status: ${response?.status}`);
      } else {
        return await response.json();
      }
    } catch (error) {
      return;
    } finally {
      setLoading(false);
    }
  };

  const handelDeleteSavedCompDoc = async (fileObj) => {
    try {
      const deleteResponse = await http.delete(
        DELETE_COMPLIANCE_DOC +
          `?ComplianceDocFileID=${fileObj?.fileId}&PropertyId=${editPropertyDetails?.propertyMasterId}&ClientId=${clientId}`
      );
      if (deleteResponse.status === 200) {
        setTimeout(() => {
          setToastData({
            toastShow: true,
            toastType: "success",
            toastString: "Document has been successfully deleted.",
          });
        }, 2000);

        editPropertyFloorDetails();
      } else {
        setTimeout(() => {
          setToastData({
            toastShow: true,
            toastType: "failure",
            toastString: "Error in deleting document, please try again.",
          });
        }, 2000);
        editPropertyFloorDetails();
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handelDeleteSavedCompDocBlock = async (fileObj, block) => {
    // const fileids = fileObj.map(item => item.docId);
    const payload = {
      blockId: block.blockId,
      propertyMasterId: editPropertyDetails.propertyMasterId,
      documentIds: [fileObj.docId],
    };
    try {
      const deleteResponse = await http.delete(DELETE_BLOCK_DOCUMENT, payload);
      if (deleteResponse.status === 200) {
        setTimeout(() => {
          setToastData({
            toastShow: true,
            toastType: "success",
            toastString: "Document has been successfully deleted.",
          });
        }, 2000);

        editPropertyFloorDetails();
      } else {
        setTimeout(() => {
          setToastData({
            toastShow: true,
            toastType: "failure",
            toastString: "Error in deleting document, please try again.",
          });
        }, 2000);
        editPropertyFloorDetails();
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  // const handleFloorInputChange = (e) => {
  //   let digits = e.target.value.replace(/\D/g, "");

  //   if (digits.length > 3) {
  //     digits = digits.slice(0, 3);
  //   }

  //   const numericValue = digits === "" ? "" : String(parseInt(digits, 10));

  //   // setShowFloorImages(Number(numericValue) > 0);
  //   setPropertyTotalFloor(numericValue);
  // };

  const handelDeleteSavedFloorImage = async (fileObj) => {
    //const floorArr = [fileObj]
    // const formDataToDeleteFloorPlan = new FormData();
    // formDataToDeleteFloorPlan.append(
    //   "ClientId",
    //   clientId
    // );
    // formDataToDeleteFloorPlan.append("PropertyMasterId", editPropertyDetails?.propertyMasterId);
    // floorArr.forEach((floor, index) => {
    //   formDataToDeleteFloorPlan.append(`FloorNumber[${index}]`, floor);
    // })
    try {
      const deleteResponse = await http.delete(
        DELETE_FLOOR_PLAN_IMAGE +
          `?ClientId=${clientId}&PropertyMasterId=${editPropertyDetails?.propertyMasterId}&FloorNumber=${fileObj}`
      );
      if (deleteResponse.status === 200) {
        setTimeout(() => {
          setToastData({
            toastShow: true,
            toastType: "success",
            toastString: "Floor Plan Image has been successfully deleted.",
          });
        }, 2000);

        editPropertyFloorDetails();
      } else {
        setTimeout(() => {
          setToastData({
            toastShow: true,
            toastType: "failure",
            toastString: "Error in deleting Image, please try again.",
          });
        }, 2000);
        editPropertyFloorDetails();
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const uploadPropertyimage = async () => {
    setLoading(true);
    const formDataToUploadPropertyImage = new FormData();
    formDataToUploadPropertyImage.append("ClientId", clientId);
    formDataToUploadPropertyImage.append(
      "PropertyMasterId",
      editPropertyDetails?.propertyMasterId
    );
    formDataToUploadPropertyImage.append("PropertyImage", propertyImage);
    try {
      const response = await fetch(hostName + UPLOAD_PROPERTY_UPDATE_IMAGE, {
        method: "POST",
        body: formDataToUploadPropertyImage,
        headers: {
          Authorization: "Bearer " + userObj?.token,
        },
      });
      if (response?.status === 401) {
        window.location.href = generatePath("/client/:clientNameParam/", {
          clientNameParam,
        });
      }
      if (response.status !== 200) {
        throw new Error(`HTTP error! status: ${response?.status}`);
      } else {
        return await response.json();
      }
    } catch (error) {
      return {};
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateProperty = async (event) => {
    event.preventDefault();
    setValidationFlag(false);
    const validationErrors = validate();
    // const isEmptyFloorEntries = checkFloorEntries(floorEntries);
    // let isEmptyAnyFloor = false;
    // let validatedFloor = floorEntries;
    // if (!isEmptyFloorEntries) {
    //   const cleaned = validatedFloor.filter((obj) => {
    //     const floorValid =
    //       obj.floor && obj.floor.trim().toLowerCase() !== "select";
    //     const imageValid = obj.image && obj.image !== null;
    //     // Keep if at least one of the two is valid
    //     return floorValid || imageValid;
    //   });
    //   console.log(cleaned);
    //   validatedFloor = validateFloorEntries(cleaned);
    //   isEmptyAnyFloor = validatedFloor.some(
    //     (entry) => entry.requireFloor !== "" || entry.requireImage !== ""
    //   );
    // }
    if (Object.keys(validationErrors).length > 0) {
      setErrorObject(validationErrors);
      setValidationFlag(true);
      const firstErrorKey = Object.keys(validationErrors)[0];
      if (firstErrorKey && inputRefs[firstErrorKey]?.current) {
        inputRefs[firstErrorKey].current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        inputRefs[firstErrorKey].current.focus();
      }
    } else {
      setLoading(true);

      let compResponse = [];
      if (files && files.length > 0) {
        const responseComplianceDocs = await uploadComplianceDocs(files);
        console.log("compl", responseComplianceDocs);
        if (responseComplianceDocs?.result?.isSuccess === true) {
          responseComplianceDocs?.result?.complianceDocFiles?.forEach(
            (file) => {
              const newObj = {
                complianceType: file.complianceType,
                complianceFileName: file.complianceFileName,
                complianceDocFileUrl: file.complianceDocFileUrl,
                fileId: file.fileId,
              };
              compResponse.push(newObj);
            }
          );
        }
      }
      let newPropertyImage = "";
      if (propertyImage && loadExistingFile) {
        const responsePropertyImage = await uploadPropertyimage();
        console.log("prop img", responsePropertyImage);
        if (responsePropertyImage?.result?.isSuccess === true) {
          newPropertyImage = responsePropertyImage?.result?.bloblUrl[0];
        }
      }
      const formDataToUploadProperty = new FormData();
      // formDataToUploadProperty.append(
      //   "PropertyImageFile",
      //   loadExistingFile ? propertyImage : ""
      // );
      formDataToUploadProperty.append(
        "propertyImage",
        loadExistingFile ? "" : propertyImage
      );
      formDataToUploadProperty.append("clientId", clientId);
      formDataToUploadProperty.append("propertyName", propertyName);
      formDataToUploadProperty.append("propertyLocation", propertyAddress);
      formDataToUploadProperty.append("postalCode", propertyPostalCode);
      formDataToUploadProperty.append(
        "isActive",
        editPropertyDetails?.isActive
      );
      formDataToUploadProperty.append(
        "cityId",
        propertyCity?.cityId ? propertyCity.cityId : ""
      );
      formDataToUploadProperty.append(
        "propertyMasterId",
        editPropertyDetails?.propertyMasterId
      );
      formDataToUploadProperty.append("NumberOfBlocks", numberofBlocks);
      formDataToUploadProperty.append("Latitude", siteLatitude);
      formDataToUploadProperty.append("Longitude", siteLongitude);

      const selectedInspector = propertyInspector?.map((u) => u.value);
      selectedInspector.forEach((value) => {
        formDataToUploadProperty.append("inspectors[]", value); // Use '[]' in the key for server-side parsing as an array
      });
      //formDataToUploadProperty.append("InspectorIds", selectedInspector);
      const selectApprover = propertyApprover?.map((u) => u.value);
      selectApprover.forEach((value) => {
        formDataToUploadProperty.append("approvers[]", value); // Use '[]' in the key for server-side parsing as an array
      });
      if (savedCompDocs && savedCompDocs.length > 0) {
        savedCompDocs?.forEach((fileObj, index) => {
          formDataToUploadProperty.append(
            `complianceDocs[${index}].complianceType`,
            fileObj.complianceType || 0
          );
          formDataToUploadProperty.append(
            `complianceDocs[${index}].complianceFileName`,
            fileObj.complianceFileName
          );
          formDataToUploadProperty.append(
            `complianceDocs[${index}].complianceDocFileUrl`,
            fileObj.complianceDocFileUrl
          );
          formDataToUploadProperty.append(
            `complianceDocs[${index}].fileId`,
            fileObj.fileId
          );
        });
      } else if (compResponse.length > 0) {
        compResponse?.forEach((fileObj, index) => {
          formDataToUploadProperty.append(
            `complianceDocs[${index}].complianceType`,
            fileObj.complianceType || 0
          );
          formDataToUploadProperty.append(
            `complianceDocs[${index}].complianceFileName`,
            fileObj.complianceFileName
          );
          formDataToUploadProperty.append(
            `complianceDocs[${index}].complianceDocFileUrl`,
            fileObj.complianceDocFileUrl
          );
          formDataToUploadProperty.append(
            `complianceDocs[${index}].fileId`,
            fileObj.fileId
          );
        });
      } else {
        formDataToUploadProperty.append(`complianceDocs`, null);
      }
      // formDataToUploadProperty.append(
      //   "totalNoOfFloors",
      //   propertyTotalFloor ? parseInt(propertyTotalFloor, 10) : null
      // );
      formDataToUploadProperty.append("propertyStatus", propertyStatus);
      console.log(
        "formDataToUploadProperty",
        formDataToUploadProperty,
        selectApprover,
        selectedInspector
      );
      // console.log("floorEntries", floorEntries);

      let complianceDocsPay = [];
      if (savedCompDocs && savedCompDocs.length > 0) {
        savedCompDocs.forEach((file) => {
          const newObj = {
            fileId: file.fileId,
            complianceType: file.complianceType,
            complianceFileName: file.complianceFileName,
            complianceDocFileUrl: file.complianceDocFileUrl,
          };
          complianceDocsPay.push(newObj);
        });
      }
      if (compResponse.length > 0) {
        compResponse.forEach((file) => {
          const newObj = {
            fileId: file.fileId,
            complianceType: file.complianceType,
            complianceFileName: file.complianceFileName,
            complianceDocFileUrl: file.complianceDocFileUrl,
          };
          complianceDocsPay.push(newObj);
        });
      }

      const newFormPayload = {
        clientId: clientId,
        propertyMasterId: editPropertyDetails?.propertyMasterId,
        isActive: editPropertyDetails?.isActive,
        propertyName: propertyName,
        propertyLocation: propertyAddress,
        postalCode: propertyPostalCode,
        propertyImage: loadExistingFile ? newPropertyImage : propertyImage,
        cityId: propertyCity?.cityId ? propertyCity.cityId.toString() : "",
        inspectors: selectedInspector,
        approvers: selectApprover,
        complianceDocs: [...complianceDocsPay],
        propertyStatus: propertyStatus,
        numberOfBlocks: numberofBlocks,
        latitude: siteLatitude,
        longitude: siteLongitude,
      };

      console.log("newFormPayload", newFormPayload);

      try {
        const response = await http.put(
          UPDATE_PROPERTY_BY_CLIENT_ID,
          JSON.stringify(newFormPayload)
        );
        console.log("update response", response);
        if (response?.status === 401) {
          window.location.href = generatePath("/client/:clientNameParam/", {
            clientNameParam,
          });
        }
        // if (response?.status === 200 && isEmptyFloorEntries) {
        //   setTimeout(() => {
        //     setToastData({
        //       toastShow: true,
        //       toastType: "success",
        //       toastString: "Property has been successfully updated.",
        //     });
        //   }, 2000);
        //   setRenderUpdateProperty(false);
        //   handleGetAllPropertyByClinetID(clientId);
        // }

        if (response.status === 200) {
          const formDataToUploadBlocks = new FormData();
          formDataToUploadBlocks.append(
            "PropertyMasterId",
            editPropertyDetails.propertyMasterId
          );
          blockData.forEach((block, index) => {
            console.log("block", block.blockName);
            const blockid = block.blockId === undefined || block.blockId === null ? crypto.randomUUID() : block.blockId;
            formDataToUploadBlocks.append(
              `Blocks[${index}].BlockId`,
              blockid
            )
            formDataToUploadBlocks.append(
              `Blocks[${index}].BlockName`,
              block.blockName
            );
            formDataToUploadBlocks.append(
              `Blocks[${index}].TotalFloors`,
              block.totalFloors
            );
            block.floorArray?.forEach((floor, ind) => {
              console.log("block", block.blockName, floor.floor, floor.image);
              formDataToUploadBlocks.append(
                `Blocks[${index}].FloorNumbers[${ind}]`,
                floor.floor
              );
              formDataToUploadBlocks.append(
                `Blocks[${index}].FloorImages[${ind}]`,
                floor.image
              );
            });
            block.additionalDocsArr.length > 0 &&
              block.additionalDocsArr.forEach((doc, ind) => {
                console.log("block", block.blockName, doc.docName);

                formDataToUploadBlocks.append(
                  `Blocks[${index}].DocumentTypes[${ind}]`,
                  doc.type
                );
                formDataToUploadBlocks.append(
                  `Blocks[${index}].DocumentFileNames[${ind}]`,
                  doc.docName
                );
                formDataToUploadBlocks.append(
                  `Blocks[${index}].DocumentFiles[${ind}]`,
                  doc.file
                );
              });
          });

          const responseFloorPlans = await fetch(
            hostName + UPDATE_BLOCKS_DATA,
            {
              method: "PUT",
              body: formDataToUploadBlocks,
              headers: {
                Authorization: "Bearer " + userObj?.token,
              },
            }
          );
          if (responseFloorPlans?.status === 401) {
            window.location.href = generatePath("/client/:clientNameParam/", {
              clientNameParam,
            });
          }
          // const responseFloorPlansData = await responseFloorPlans.json();
          if (responseFloorPlans.status === !200) {
            setTimeout(() => {
              setToastData({
                toastShow: true,
                toastType: "failure",
                toastString: "Property has not been updated, please try again.",
              });
            }, 2000);
            setRenderUpdateProperty(false);
            handleGetAllPropertyByClinetID(clientId);
          }
          if (responseFloorPlans.status === 200) {
            setTimeout(() => {
              setToastData({
                toastShow: true,
                toastType: "success",
                toastString: "Property has been successfully updated.",
              });
            }, 2000);
            setRenderUpdateProperty(false);
            handleGetAllPropertyByClinetID(clientId);
          }
        } else if (response.status === 400) {
          setTimeout(() => {
            setToastData({
              toastShow: true,
              toastType: "failure",
              toastString: response?.message,
            });
          }, 2000);
        } else {
          throw new Error(`HTTP error! status: ${response?.status}`);
        }
      } catch (error) {
        return {};
      } finally {
        setLoading(false);
      }
    }
  };

  // const checkFloorEntries = (entries) => {
  //   const isObjectValuesEmpty = (obj) => {
  //     return Object.values(obj).every(
  //       (value) =>
  //         value === null ||
  //         value === undefined ||
  //         value === "" ||
  //         value === "Select" ||
  //         value === "Please select floor" ||
  //         value === "Please upload floor plan image"
  //     );
  //   };

  //   return entries.every(isObjectValuesEmpty);
  // };
  const handleSelect = (e) => {
    if (e.target.name === "city") {
      const foundObject = cityList.find(
        (option) => option.cityName === e.target.value
      );
      setPropertyCity(foundObject);
    }
    // } else if (e.target.name === "block") {
    //   const foundObject = blocksList.find(
    //     (option) => option.blockName === e.target.value
    //   );
    //   // setPropertyBlockName(foundObject);
    // }
    setErrorObject((prevErrors) => ({
      ...prevErrors,
      [e.target.name]: e.target.value ? "" : prevErrors.totalFloor,
    }));
  };

  useEffect(() => {
    setBlockData((prev) => {
      const next = Array.from(
        { length: numberofBlocks },
        (_, i) =>
          prev[i] ?? {
            id: i + 1,
            blockName: "",
            totalFloors: 0,
            showFloorImages: false,
            floorArray: [],
            additionalDocsArr: [],
            fileError: "",
            fileShowValidation: false,
            formErrors: {}, // add these
            hasFormErrors: false,
          }
      );
      return next;
    });
  }, [numberofBlocks]);

  const buildMergedFloorArray = (prevFloors, normalized) => {
    // Ensure we always work with an array
    const prevByFloor = new Map((prevFloors ?? []).map((f) => [f.floor, f]));

    // Build the target range 1..normalized and merge existing data
    return Array.from({ length: normalized }, (_, i) => {
      const floorNo = i + 1;
      const prev = prevByFloor.get(floorNo);
      return {
        blockFloorId: prev?.blockFloorId ?? null,
        floor: floorNo,
        loadedImage: prev?.loadedImage ?? false,
        image: prev?.image ?? null, // ✅ keep existing image if present
        floorError: prev?.floorError ?? "", // ✅ keep existing error if present
      };
    });
  };

  const handleBlockDataChange = (index, field, val) => {
    if (field === "totalFloors") {
      let digits = val.replace(/\D/g, ""); // keep only 0–9
      if (digits.length > 3) {
        digits = digits.slice(0, 3);
      }
      const normalized = digits === "" ? "" : String(parseInt(digits, 10));
      const numericValue = normalized === "" ? 0 : Number(normalized);
      // const floorarr = Array.from({ length: normalized }, (_, i) => ({
      //   floor: i + 1,
      //   image: null,
      //   floorError: "",
      // }));
      const nextFloors = buildMergedFloorArray(
        blockData[index].floorArray,
        normalized
      );
      console.log("next", nextFloors);
      setBlockData((prev) =>
        prev.map((item, i) =>
          i === index
            ? {
                ...item,
                totalFloors: normalized,
                showFloorImages: normalized !== "" && numericValue > 0,
                floorArray: nextFloors,
                formErrors: {
                  ...item.formErrors,
                  [field]: "", // ✅ clear error for this field only
                },
              }
            : item
        )
      );
    } else if (field === "additionalDocsArr") {
      setBlockData((prev) =>
        prev.map((item, i) => {
          if (i !== index) return item;

          const prevFieldValue = item[field]; // e.g., previous additionalDocsArr

          const nextFieldValue =
            typeof val === "function" ? val(prevFieldValue) : val;

          return { ...item, [field]: nextFieldValue };
        })
      );
    } else {
      setBlockData((prev) =>
        prev.map((item, i) =>
          i === index
            ? {
                ...item,
                [field]: val,
                formErrors: {
                  ...item.formErrors,
                  [field]: "", // ✅ clear error for this field only
                },
              }
            : item
        )
      );
    }
  };

  const handleBlockFloorImageChange = (blockIndex, floorNumber, e) => {
    const file = e.target.files?.[0] ?? null;

    setBlockData((prev) =>
      prev.map((block, i) => {
        if (i !== blockIndex) return block;

        const nextFloorArray = block.floorArray.map((f) =>
          f.floor === floorNumber ? { ...f, image: file, floorError: "" } : f
        );

        return {
          ...block,
          floorArray: nextFloorArray,
          fileError: "",
          fileShowValidation: false,
        };
      })
    );
  };

  const removeFloorImage = (blockIndex, floorNumber) => {
    setBlockData((prev) =>
      prev.map((block, i) => {
        if (i !== blockIndex) return block;

        const nextFloorArray = block.floorArray.map((f) =>
          f.floor === floorNumber ? { ...f, image: null } : f
        );

        return { ...block, floorArray: nextFloorArray };
      })
    );

    const el = fileInputRefs.current[blockIndex]?.[floorNumber];
    if (el) el.value = "";
  };

  const handleKeyDown = (e) => {
    if (e.key === "." || e.key === "e" || e.key === "-") {
      e.preventDefault();
    }
  };

  const fileInputRefs = useRef({}); // nested map: { [blockIndex]: { [floorNumber]: HTMLInputElement } }

  const setFileInputRef = (blockIndex, floorNumber) => (el) => {
    if (!el) return;
    if (!fileInputRefs.current[blockIndex])
      fileInputRefs.current[blockIndex] = {};
    fileInputRefs.current[blockIndex][floorNumber] = el;
  };

  return (
    <>
      <div className="d-flex dashboard_body flex-column py-1 w-100 mt-2">
        <div className="dashboard_header">
          <h2 className="mb-0">Update Site Details</h2>
          <div className="d-flex flex-row justify-content-between">
            <p className="header-description">
              Update site/block details below.
            </p>
          </div>
        </div>
        <div className="mb-3 mt-2 tab-container">
          <button
            className={
              activeTab === "Site" ? "btn btn-tab-active" : "btn btn-tab"
            }
            onClick={() => handleTabChange("Site")}
          >
            Site Information
          </button>
          <button
            className={
              activeTab === "Block" ? "btn btn-tab-active" : "btn btn-tab"
            }
            onClick={() => handleTabChange("Block")}
          >
            Block Information
          </button>
        </div>
        {activeTab === "Site" && (
          <>
            <div className="resident-card d-flex flex-column gap-2 mt-3 text-start">
              <h3 className="resident-card-header">Site Information</h3>
              <div className="card-body-uneven-section">
                <div className="form-group">
                  <label htmlFor="name">
                    Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter site name"
                    id={`name1`}
                    className={errorObject.propertyName ? "input-error" : ""}
                    value={propertyName}
                    onChange={(e) => {
                      setPropertyName(e.target.value);
                      setErrorObject((prevErrors) => ({
                        ...prevErrors,
                        propertyName: e.target.value
                          ? ""
                          : prevErrors.propertyName,
                      }));
                    }}
                    ref={inputRefs.propertyName}
                  />
                  {errorObject.propertyName && (
                    <span className="formError">
                      {errorObject.propertyName}
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="address1">
                    Address <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter site address"
                    id="address"
                    className={errorObject.propertyAddress ? "input-error" : ""}
                    value={propertyAddress}
                    onChange={(e) => {
                      setPropertyAddress(e.target.value);
                      setErrorObject((prevErrors) => ({
                        ...prevErrors,
                        propertyAddress: e.target.value
                          ? ""
                          : prevErrors.propertyAddress,
                      }));
                    }}
                    ref={inputRefs.propertyAddress}
                  />
                  {errorObject.propertyAddress && (
                    <span className="formError">
                      {errorObject.propertyAddress}
                    </span>
                  )}
                </div>
              </div>
              <div className="card-body-three-section">
                <div className="form-group">
                  <label htmlFor="contact1">
                    Post code <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter post code"
                    className={errorObject.postalCode ? "input-error" : ""}
                    id={`contact1`}
                    value={propertyPostalCode}
                    onChange={(e) => {
                      let formattedValue = e.target.value
                        .toUpperCase()
                        .replace(/\s+/g, "");
                      if (formattedValue.length > 5) {
                        formattedValue =
                          formattedValue.slice(0, -3) +
                          " " +
                          formattedValue.slice(-3);
                      }
                      setPropertyPostalCode(formattedValue);
                      setErrorObject((prevErrors) => ({
                        ...prevErrors,
                        postalCode: e.target.value ? "" : prevErrors.postalCode,
                      }));
                    }}
                    ref={inputRefs.postalCode}
                  />

                  {errorObject.postalCode && (
                    <span className="formError">{errorObject.postalCode}</span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="contact1">
                    City <span style={{ color: "red" }}>*</span>
                  </label>
                  <select
                    id={`floor-select`}
                    name="city"
                    className={errorObject.city ? "input-error" : ""}
                    value={propertyCity?.cityName}
                    onChange={(e) => {
                      handleSelect(e);
                      setErrorObject((prevErrors) => ({
                        ...prevErrors,
                        city: e.target.value ? "" : prevErrors.city,
                      }));
                    }}
                    aria-label="Floating label select example"
                    ref={inputRefs.city}
                  >
                    <option selected>Select City</option>
                    {cityList?.map((data) => (
                      <option key={data.cityId} value={data.cityName}>
                        {data.cityName}
                      </option>
                    ))}
                  </select>
                  {errorObject.city && (
                    <span className="formError">{errorObject.city}</span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="contact1">Select Site Status</label>
                  <select
                    id={`floor-select-`}
                    value={propertyStatus}
                    onChange={(e) => setPropertyStatus(e.target.value)}
                    aria-label="Floating label select example"
                  >
                    <option selected value="Active">
                      Active
                    </option>
                    <option value="Archive">Archive</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="name">
                    Number of Blocks <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="number"
                    placeholder="Enter number of blocks"
                    id={`name1`}
                    className={errorObject.numberofBlocks ? "input-error" : ""}
                    min={0}
                    value={numberofBlocks}
                    onChange={(e) => {
                      setNumberofBlocks(e.target.value);
                      //   createObjects(e.target.value);
                      setErrorObject((prevErrors) => ({
                        ...prevErrors,
                        numberofBlocks: e.target.value
                          ? ""
                          : prevErrors.numberofBlocks,
                      }));
                    }}
                    ref={inputRefs.numberofBlocks}
                  />
                  {errorObject.numberofBlocks && (
                    <span className="formError">
                      {errorObject.numberofBlocks}
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="name">
                    Latitude <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="e.g., 53.483959"
                    id={`name1`}
                    value={siteLatitude}
                    className={errorObject.siteLatitude ? "input-error" : ""}
                    onChange={(e) => {
                      setSiteLatitude(e.target.value);
                      setErrorObject((prevErrors) => ({
                        ...prevErrors,
                        siteLatitude: e.target.value
                          ? ""
                          : prevErrors.siteLatitude,
                      }));
                    }}
                    ref={inputRefs.latitude}
                  />
                  {errorObject.siteLatitude && (
                    <span className="formError">
                      {errorObject.siteLatitude}
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="name">
                    Longitude <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="e.g., -2.244644"
                    className={errorObject.siteLongitude ? "input-error" : ""}
                    id={`name1`}
                    value={siteLongitude}
                    onChange={(e) => {
                      setSiteLongitude(e.target.value);
                      setErrorObject((prevErrors) => ({
                        ...prevErrors,
                        siteLongitude: e.target.value
                          ? ""
                          : prevErrors.siteLongitude,
                      }));
                    }}
                    ref={inputRefs.longitude}
                  />
                  {errorObject.siteLongitude && (
                    <span className="formError">
                      {errorObject.siteLongitude}
                    </span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="contact1">
                    Select Inspector(s)
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    isMulti
                    options={inspectorList}
                    value={propertyInspector}
                    required
                    ref={inputRefs.inspectors}
                    className={errorObject.inspectors ? "input-error" : ""}
                    onChange={(e) => {
                      setPropertyInspector(e);

                      setErrorObject((prevErrors) => ({
                        ...prevErrors,
                        inspector: "",
                      }));
                    }}
                    placeholder="Select Inspector"
                    isClearable
                    menuPortalTarget={document.body}
                    styles={{
                      container: (base) => ({
                        ...base,
                        width: "100%",
                        height: "2.81rem",
                      }),
                      control: (base) => ({
                        ...base,
                        minHeight: "2.81rem",
                      }),
                      placeholder: (base) => ({
                        ...base,
                        textAlign: "left",
                        marginLeft: "1rem",
                        color: "#a3a3a3",
                        opacity: 0.8,
                      }),
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999,
                      }),
                    }}
                  />
                  {errorObject.inspectors && (
                    <span className="formError">{errorObject.inspectors}</span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="contact1">
                    Select Approver(s)
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <Select
                    isMulti
                    className={errorObject.approvers ? "input-error" : ""}
                    options={approverList}
                    value={propertyApprover}
                    required
                    onChange={(e) => {
                      setErrorObject((prevErrors) => ({
                        ...prevErrors,
                        approvers: "",
                      }));
                      setPropertyApprover(e);
                    }}
                    placeholder="Select Approvers"
                    isClearable
                    ref={inputRefs.approvers}
                    menuPortalTarget={document.body}
                    styles={{
                      container: (base) => ({
                        ...base,
                        width: "100%",
                        height: "2.81rem",
                      }),
                      control: (base) => ({
                        ...base,
                        minHeight: "2.81rem",
                      }),
                      placeholder: (base) => ({
                        ...base,
                        textAlign: "left",
                        marginLeft: "1rem",
                        color: "#a3a3a3",
                        opacity: 0.8,
                      }),
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999,
                      }),
                    }}
                  />
                  {errorObject.approvers && (
                    <span className="formError">{errorObject.approvers}</span>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="contact1">Main door Image</label>
                  {loadExistingFile && (
                    <div
                      className={`d-flex justify-content-between customerFileBtn align-items-center gap-2 m-0 flex-row`}
                    >
                      <label
                        className="input-group-text mb-0"
                        htmlFor="inputGroupFile"
                        style={{
                          // height: "36px",
                          fontSize: "15px",
                          lineHeight: 2,
                          color: " #081634",
                          backgroundColor: "white",
                          border: "1px solid #081634",
                          borderRadius: "5px",
                        }}
                      >
                        Choose File
                      </label>
                      <input
                        type="file"
                        id="inputGroupFile"
                        // style={{
                        //   height: "36px",
                        //   border: "none",
                        //   color: "#6B7280",
                        // }}
                        accept=".jpg, .jpeg, .png, .gif"
                        onChange={handleFileChange}
                        // ref={fileInputRef}
                      />
                    </div>
                  )}
                  {!loadExistingFile && (
                    <div className="updateMainDoorDiv gap-2 d-flex align-items-justify">
                      <img
                        height="150px"
                        width="180px"
                        alt="Main Door Photo"
                        className="img-fluid w-48 h-48 object-cover rounded-lg border"
                        style={{ marginTop: "5px" }}
                        src={
                          ImageProxyBaseUrl + encodeURIComponent(propertyImage)
                        }
                      />
                      <button
                        onClick={() => {
                          setLoadExistingFile(true);
                        }}
                        className="  btn-primary "
                      >
                        <i className="fa fa-solid fa-pen"></i> Update Image
                      </button>
                    </div>
                  )}
                  {/* {previewPropertImage && (
                    <div className="mt-2">
                      <p className="text-sm text-gray-600 mb-1">Preview:</p>
                      <img
                        height="150px"
                        width="150px"
                        src={previewPropertImage}
                        alt="Main Door"
                        className="w-48 h-48 object-cover rounded-lg border"
                      />
                    </div>
                  )} */}
                </div>
              </div>
            </div>
            <div className="resident-card d-flex flex-column gap-2 mt-3 text-start">
              <h3 className="resident-card-header">Site Documents</h3>
              <FileUpload
                setFiles={setFiles}
                files={files}
                setError={setError}
                error={error}
                setShowValidation={setShowValidation}
                showValidation={showValidation}
                savedCompDocs={savedCompDocs}
                handleDeleteSaved={handelDeleteSavedCompDoc}
              />
            </div>
          </>
        )}
        {activeTab === "Block" && blockData.length === 0 && (
          <div className="mt-3">
            Enter Number of blocks to add Block information
          </div>
        )}
        {activeTab === "Block" &&
          blockData.length > 0 &&
          blockData.map((block, index) => {
            return (
              <div
                key={index}
                className="resident-card d-flex flex-column gap-2 mt-3 text-start"
              >
                <h3 className="resident-card-header">Block - {index + 1}</h3>
                <div className="card-body-section">
                  <div className="form-group">
                    <label htmlFor="name">
                      Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className={
                        block.formErrors?.blockName ? "input-error" : ""
                      }
                      placeholder="Enter block name"
                      id={`name1`}
                      name="blockName"
                      value={block.blockName}
                      onChange={(e) => {
                        handleBlockDataChange(
                          index,
                          "blockName",
                          e.target.value
                        );
                      }}
                    />

                    {block.formErrors?.blockName && (
                      <div className="formError">
                        {block.formErrors.blockName}
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="name">
                      Total Floors <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="number"
                      className={
                        block.formErrors?.totalFloors ? "input-error" : ""
                      }
                      placeholder="Enter total floors"
                      id={`name1`}
                      name="totalFloors"
                      value={block.totalFloors}
                      onKeyDown={handleKeyDown}
                      onChange={(e) => {
                        handleBlockDataChange(
                          index,
                          "totalFloors",
                          e.target.value
                        );
                      }}
                    />
                    {block.formErrors?.totalFloors && (
                      <div className="formError">
                        {block.formErrors.totalFloors}
                      </div>
                    )}
                  </div>
                </div>
                {block.floorArray.length > 0 &&
                  block.floorArray.map((floor, i) => {
                    return (
                      <div key={i} className="card-body-section">
                        <div className="form-group">
                          <label htmlFor="name">
                            Floor Number <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="number"
                            placeholder="Enter total floors"
                            id={`name1`}
                            disabled
                            name="totalFloors"
                            value={floor.floor}
                            onKeyDown={handleKeyDown}
                            onChange={(e) => {
                              handleBlockDataChange(
                                index,
                                "totalFloors",
                                e.target.value
                              );
                            }}
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="contact1">
                            Floor Plan Image{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          {!floor.loadedImage && (
                            <div
                              className={`d-flex justify-content-between customerFileBtn align-items-center gap-2 m-0 flex-row`}
                            >
                              <label
                                className="input-group-text mb-0"
                                htmlFor={`inputGroupFile-${index}-${floor.floor}`}
                                style={{
                                  // height: "36px",
                                  fontSize: "15px",
                                  lineHeight: 2,
                                  color: " #081634",
                                  backgroundColor: "white",
                                  border: "1px solid #081634",
                                  borderRadius: "5px",
                                }}
                              >
                                Choose File
                              </label>
                              <input
                                type="file"
                                className={
                                  floor.floorError ? "input-error" : ""
                                }
                                id={`inputGroupFile-${index}-${floor.floor}`}
                                accept=".jpg, .jpeg, .png, .gif"
                                ref={setFileInputRef(index, floor.floor)}
                                onChange={(e) => {
                                  handleBlockFloorImageChange(
                                    index,
                                    floor.floor,
                                    e
                                  );
                                }}
                              />
                              <img
                                src={delicon}
                                alt="Delete"
                                onClick={() =>
                                  removeFloorImage(index, floor.floor)
                                }
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  cursor: "pointer",
                                  marginLeft: "1rem",
                                }}
                              />
                            </div>
                          )}
                          {floor.loadedImage && (
                            <div className="floorplan-item">
                              <img
                                // style={{
                                //   height: "50px",
                                //   marginTop: "5px",
                                // }}
                                src={
                                  ImageProxyBaseUrl +
                                  encodeURIComponent(floor?.image)
                                }
                                alt="Background"
                                className="img-fluid"
                              />
                              <div className="floorplan-overlay">
                                <div className="floorplanbutton-group">
                                  <i
                                    className="fa-solid fa-xmark pointer"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setFloorNumberToDelete({
                                        block: index,
                                        floor: floor.floor,
                                      });
                                      setShowConfirmationPopup({
                                        show: true,
                                        headingText: "Delete Floor Image",
                                        infoText:
                                          "Are you sure you want to delete this floor image?",
                                        cancelText: "Cancel",
                                        submittext: "Delete",
                                      });
                                    }}
                                  ></i>
                                </div>
                              </div>
                            </div>
                          )}
                          {floor.floorError && (
                            <div className="formError">{floor.floorError}</div>
                          )}
                        </div>
                      </div>
                    );
                  })}

                <h3 className="resident-card-header mt-2">
                  Additional documents
                </h3>
                <FileUpload
                  setFiles={(files) => {
                    handleBlockDataChange(index, "additionalDocsArr", files);
                  }}
                  files={block.additionalDocsArr}
                  setError={(err) => {
                    handleBlockDataChange(index, "fileError", err);
                  }}
                  error={block.fileError}
                  setShowValidation={(val) => {
                    handleBlockDataChange(index, "fileShowValidation", val);
                  }}
                  showValidation={block.fileShowValidation}
                  savedCompDocs={block.savedadditionalDocsArr}
                  handleDeleteSaved={(file) =>
                    handelDeleteSavedCompDocBlock(file, block)
                  }
                />
              </div>
            );
          })}

        <div className="button-container align-items-center">
          <button
            type="submit"
            className="btn-primary  col-sm-5 col-md-2"
            onClick={handleUpdateProperty}
          >
            Update
          </button>
          <button
            type="button"
            className="btn-secondary  col-sm-5 col-md-2"
            onClick={() => {
              setRenderUpdateProperty(false);
            }}
          >
            Cancel
          </button>
          {validationFlag && (
            <div style={{ color: "red" }} className="me-auto">
              * Please fill all required fields
            </div>
          )}
        </div>
      </div>
      <LoadingComponent loading={loading} />
      <ConfirmationPopup
        show={showConfirmationPopup.show}
        headingText={showConfirmationPopup.headingText}
        infoText={showConfirmationPopup.infoText}
        cancelText={showConfirmationPopup.cancelText}
        submitText={showConfirmationPopup.submittext}
        onCancel={() => {
          setShowConfirmationPopup({
            ...showConfirmationPopup,
            show: false,
            headingText: "",
            infoText: "",
            cancelText: "",
            submittext: "",
          });
        }}
        onSubmit={() => {
          setShowConfirmationPopup({
            ...showConfirmationPopup,
            show: false,
            headingText: "",
            infoText: "",
            cancelText: "",
            submittext: "",
          });
          handelDeleteSavedFloorImage(floorNumberToDelete);
        }}
      />
    </>
  );
};
export default UpdateProperty;
